(function () {
  function getFlickityButtons(section) {
    var carousel = section.querySelector('[data-related-products]');
    if (!carousel) return {};

    return {
      prev: carousel.querySelector('.flickity-button.previous'),
      next: carousel.querySelector('.flickity-button.next')
    };
  }

  function syncNav(section) {
    var flickity = getFlickityButtons(section);
    var prevBtns = section.querySelectorAll('[data-fclo-related-prev]');
    var nextBtns = section.querySelectorAll('[data-fclo-related-next]');

    prevBtns.forEach(function (btn) {
      btn.disabled = !flickity.prev || flickity.prev.disabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = !flickity.next || flickity.next.disabled;
    });
  }

  function bindNav(section) {
    if (section.dataset.fcloRelatedBound === 'true') return;
    section.dataset.fcloRelatedBound = 'true';

    var prevBtns = section.querySelectorAll('[data-fclo-related-prev]');
    var nextBtns = section.querySelectorAll('[data-fclo-related-next]');
    if (!prevBtns.length) return;

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flickity = getFlickityButtons(section);
        if (flickity.prev) flickity.prev.click();
        window.setTimeout(function () { syncNav(section); }, 50);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var flickity = getFlickityButtons(section);
        if (flickity.next) flickity.next.click();
        window.setTimeout(function () { syncNav(section); }, 50);
      });
    });

    section.addEventListener('theme:related-products:added', function () {
      window.setTimeout(function () {
        syncNav(section);

        var flickity = getFlickityButtons(section);
        if (!window.MutationObserver) return;

        if (flickity.prev) {
          new MutationObserver(function () { syncNav(section); }).observe(flickity.prev, {
            attributes: true,
            attributeFilter: ['disabled']
          });
        }
        if (flickity.next) {
          new MutationObserver(function () { syncNav(section); }).observe(flickity.next, {
            attributes: true,
            attributeFilter: ['disabled']
          });
        }
      }, 200);
    });

    var tries = 0;
    var retry = window.setInterval(function () {
      syncNav(section);
      tries += 1;
      if (tries > 25) window.clearInterval(retry);
    }, 200);
  }

  function initSection(section) {
    if (!section || !section.classList.contains('fclo-related')) return;
    bindNav(section);
  }

  document.querySelectorAll('[data-section-type="related"].fclo-related').forEach(initSection);

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    var section = target.matches('[data-section-type="related"]')
      ? target
      : target.querySelector('[data-section-type="related"]');
    if (section) initSection(section);
  });
})();
